import classNames from 'classnames';
import React from 'react';
import { IconSizes } from '../StyledIcon';
import { green, orange } from '../../Styles/Colours';
import { LockedPadlockIcon, UnlockedPadlockIcon } from '../Icons';
import styles from './DraftPublishedChip.module.scss';

export enum DraftPublishedChipStatus {
    Draft,
    Published
}

export const DraftPublishedChip: React.FC<{
    status: DraftPublishedChipStatus;
}> = props => {
    const iconSize: IconSizes = '12';

    const isPublished: boolean = props.status === DraftPublishedChipStatus.Published;
    const padlockColour = isPublished ? green : orange;
    const rosterStatus: string = isPublished ? 'published' : 'draft';

    const padlock = isPublished ? (
        <LockedPadlockIcon size={iconSize} color={padlockColour} />
    ) : (
        <UnlockedPadlockIcon size={iconSize} color={padlockColour} />
    );

    const padlockComponent = <div className={styles.padlock}>{padlock}</div>;
    const rosterStatusComponent = <div className={styles.text}>{rosterStatus}</div>;

    return (
        <div
            className={classNames(styles.content, styles.status, {
                [styles.published]: props.status === DraftPublishedChipStatus.Published,
                [styles.draft]: props.status === DraftPublishedChipStatus.Draft
            })}
        >
            {padlockComponent}
            {rosterStatusComponent}
        </div>
    );
};
